module.exports = __webpack_public_path__ + "img/1746604937_kwwA.85bad74d.jpg";